module.exports = "<h1 id=\"vbl-css\">vbl.css</h1>\n<p>公共css</p>\n<h2 id=\"installation\">Installation</h2>\n<pre><code>$ npm install vbl.css --save\n</code></pre>";


//////////////////
// WEBPACK FOOTER
// ./src/vbl.css/README.md
// module id = 133
// module chunks = 0